<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import TableColumn from '../../../components/Table/TableColumn.vue'
import TypographyItem from '../../../components/Typography/TypographyItem.vue'
import { EDetectionActions } from '../../../store/detectionStore/DetectionStoreTypes'
import { formatTimestamp } from '../../../utils/dateUtils'
import DetectionsTableView from '../DetectionsTableView.vue'

const { t } = useI18n()

const columns = computed(() => ({
    origin_name: { field: 'origin_name', label: t('detection.table.origin_name') },
    destination_name: { field: 'destination_name', label: t('detection.table.destination_name') },
    epc: { field: 'epc', label: t('detection.table.epc') },
    epc_type: { field: 'epc_type', label: t('detection.table.epc_type') },
    start_at: { field: 'start_at', label: t('detection.table.start_at') },
    end_at: { field: 'end_at', label: t('detection.table.end_at') }
}))
</script>

<template>
    <DetectionsTableView
        :storeAction="EDetectionActions.FETCH_TRIPS"
        :storeExportAction="EDetectionActions.EXPORT_TRIPS">
        <template #columns>
            <TableColumn
                :field="columns['origin_name'].field"
                :label="columns['origin_name'].label" />
            <TableColumn
                :field="columns['destination_name'].field"
                :label="columns['destination_name'].label" />
            <TableColumn :field="columns['epc'].field" :label="columns['epc'].label" />
            <TableColumn
                :field="columns['start_at'].field"
                :label="columns['start_at'].label"
                v-slot="props">
                <TypographyItem
                    v-if="props.row.start_at"
                    :label="formatTimestamp(props.row.start_at)" />
            </TableColumn>
            <TableColumn
                :field="columns['end_at'].field"
                :label="columns['end_at'].label"
                v-slot="props">
                <TypographyItem
                    v-if="props.row.end_at"
                    :label="formatTimestamp(props.row.end_at)" />
            </TableColumn>
        </template>
    </DetectionsTableView>
</template>
